import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({ baseURL: API_URL });

export const fileUrl = (p) => (p ? `${API_URL}${p}` : '');

export default api;
